import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

const ReportingPage: FC = () => {
  const { t } = useTranslation();

  return (
    <div>
      <h1>{t('reporting_page_title')}</h1>
      {/* Add page-specific content here */}
    </div>
  );
}

export default ReportingPage;
